import React from 'react';
import { Box, Typography } from '@mui/material';

interface MessageContent {
  type: string;
  header?: { type: string; text: string };
  body?: { type: string; text?: string; system_message?: string };
  footer?: { type: string; text: string };
}

interface Message {
  content: MessageContent;
  origin: 'INBOUND' | 'OUTBOUND';
}

interface MessageProps {
  message: Message;
}

const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')        
    .replace(/_(.*?)_/g, '<i>$1</i>')        
    .replace(/~(.*?)~/g, '<s>$1</s>')       
    .replace(/```(.*?)```/g, '<code>$1</code>') 
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
    .replace(/\n/g, '<br />');                 
};


const OpenAIMessage: React.FC<MessageProps> = ({ message }) => {
  try {
    const content = message?.content || {};
    const headerText = content?.header?.text || '';
    const bodyText = content?.body?.text || content?.body?.system_message || 'No content available.';
    const footerText = content?.footer?.text || '';

    return (
      <Box>
        {/* Header */}
        {headerText && (
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom dangerouslySetInnerHTML={{ __html: formatText(headerText) }}
>
            {/* {headerText} */}
          </Typography>
        )}

        {/* Body */}
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: footerText ? 2 : 0 }} dangerouslySetInnerHTML={{ __html: formatText(bodyText) }}
 >
          {/* {bodyText} */}
        </Typography>

        {/* Footer */}
        {footerText && (
          <Typography variant="caption" color="text.secondary" display="block" dangerouslySetInnerHTML={{ __html: formatText(footerText) }}
>
            {/* {footerText} */}
          </Typography>
        )}
      </Box>
    );
  } catch (error) {
    return <Typography color="error">Error displaying AI message</Typography>;
  }
};

export default OpenAIMessage;

